import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import TableRow from "@mui/material/TableRow";
import { Tag } from "../../../../../../models";
import { ROUTES } from "../../../../../../history";

import AppLink from "../../../../../../components/AppLink";
import { getAppointmentPrice, to2DecimalPlaces } from "../../../../../../helpers";
import dayjs from "dayjs";




const SpecializationListWidget: React.FC<{
  specialization: Tag;
  active?: boolean;
  avatarBgColor?: string;
  onClickCheck?: (p: Tag) => void;
}> = ({
  specialization,
  active = false,

  onClickCheck,
}) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        <Box display="flex" alignItems={"center"}>
          <Box
            display="inline-block"
            sx={{
              mr: 1,
            }}
          >
            <Checkbox
              checked={active}
              onChange={() => {
                if (onClickCheck) {
                  onClickCheck(specialization);
                }
              }}
            />
          </Box>
          <AppLink
            doNotUseButton
            to={
              ROUTES.ADMIN_BASE + '/settings/app-settings' +
              "/doctor-specializations/view/" +
              specialization.id
            }
          >
            <Typography component="span" fontSize="14px" fontWeight={"bold"}>
            {specialization.name}
            </Typography>
          </AppLink>
        </Box>
      </TableCell>
  
      
      <TableCell align="right">NGN{to2DecimalPlaces(getAppointmentPrice(specialization), true)}</TableCell>
      <TableCell align="right">
        
        {dayjs(specialization.createdAt).format("MMM D, YYYY")}

      </TableCell>
    </TableRow>
  );
};

export default SpecializationListWidget;
